<template>
  <div>
    <div>
      <section class="hero is-medium background">
        <div class="hero-body">
          <div class="container">
            <div class="columns is-desktop">
              <div class="column is-one-fourth">
                <div class="card  card-equal-height has-text-centered">
                  <div class="card-image py-4 px-4">
                    <figure class="image is-square">
                      <img src="warranty_credit.png" alt="Placeholder image">
                    </figure>
                  </div>
                  <div class="card-content">
                    <div class="content">
                      <p class="title is-4 has-text-white">WARRANTY CREDIT REQUEST</p>
                      <p class="subtitle is-6  mt-2 has-text-white">
                        Create and review your credit requests for work you have performed on your customers DVO product
                        that is covered under warranty.
                      </p>
                    </div>
                  </div>
                  <div class="card-footer pb-6">
                    <p class="card-footer-item">
                      <b-button 
                        to="/warranty-credit-request" 
                        tag="router-link"
                        type="is-dvogreen">
                        Check It Out
                    </b-button>
                    </p>
                  </div>
                </div>
              </div>
              <div class="column is-one-fourth">
                <div class="card  card-equal-height has-text-centered">
                  <div class="card-image py-4 px-4">
                    <figure class="image is-square">
                      <img src="marketing.png" alt="Placeholder image">
                    </figure>
                  </div>
                  <div class="card-content">
                    <div class="content">
                      <p class="title is-4 has-text-white">MARKETING MATERIAL</p>
                      <p class="subtitle is-6  mt-2 has-text-white">
                        Get acces to all the visual tools to help you market and sell DVO Suspension. Manuals & tech
                        documents are included
                      </p>
                    </div>
                  </div>
                  <div class="card-footer pb-6">
                    <p class="card-footer-item">
                      <b-button 
                        :href="this.marketingLink"  
                        tag="a"
                        type="is-dvogreen">
                        Check It Out
                    </b-button>
                    </p>
                  </div>
                </div>
              </div>
              <div class="column is-one-fourth">
                <div class="card  card-equal-height has-text-centered">
                  <div class="card-image py-4 px-4">
                    <figure class="image is-square">
                      <img src="fork.png" alt="Placeholder image">
                    </figure>
                  </div>
                  <div class="card-content">
                    <div class="content">
                      <p class="title is-4 has-text-white">LATEST UPDATES</p>
                      <p class="subtitle is-6  mt-2 has-text-white">
                        We're always working to improve user experience and product performance. Stay up to date with
                        the latest tech and service bulletins
                      </p>
                    </div>
                  </div>
                  <div class="card-footer pb-6">
                    <p class="card-footer-item">
                      <b-button 
                        :href="this.techLink"
                        tag="a"
                        type="is-dvogreen">
                        Check It Out
                    </b-button>
                    </p>
                  </div>
                </div>
              </div>
              <div class="column is-one-fourth">
                <div class="card  card-equal-height has-text-centered">
                  <div class="card-image py-4 px-4">
                    <figure class="image is-square">
                      <img src="shocking.png" alt="Placeholder image">
                    </figure>
                  </div>
                  <div class="card-content">
                    <div class="content">
                      <p class="title is-4 has-text-white">PRICING & E-CATALOGUE</p>
                      <p class="subtitle is-6  mt-2 has-text-white">
                        Access the most recent price sheets, eCatalog and data import files
                      </p>
                    </div>
                  </div>
                  <div class="card-footer pb-6">
                    <p class="card-footer-item">
                      <b-button 
                        to="/products" 
                        tag="router-link"
                        type="is-dvogreen">
                        Check It Out
                    </b-button>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns is-centered">
              <div class="column has-text-centered has-text-white">
                  <p>Need to register your own product? Click <router-link :to="{ path: '/register-item'}">Here!</router-link></p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { API } from 'aws-amplify';
import { adminUtilHandler } from '../graphql/mutations'
import { mapState } from "vuex";

export default {
  data(){
    return{
      techLink: null,
      marketingLink: null,
    }
  },
  methods: {
    async getLinks(){
    const Util = {
        id: 1,
        request_type: 'read_one'
      };
    const utils = await API.graphql({
        query: adminUtilHandler,
        variables: 
        {        
        input: Util,
        }
    });
    this.marketingLink = utils.data.adminUtilHandler.marketing_material
    this.techLink = utils.data.adminUtilHandler.tech_news
    },
  },
  mounted(){
    this.getLinks()
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  name: 'Home'
}
</script>
<style scoped>
.card {
  border-radius: 20px;

}
.title{
  font-family:  'Anton', sans-serif;
}
.subtitle{
  font-family: 'Roboto', sans-serif;
  font-weight: 100;
}
.card-equal-height {
   display: flex;
   flex-direction: column;
   height: 100%;
}
.card-equal-height .card-footer {
  margin-top: auto;
}
.card-footer{
  border: none;
}
</style>
